import React, { Component } from 'react';
import {
  NavDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

class ActiveBrandsDropDown extends Component {
  constructor(props){
    super();

    this.state = {
      open:false,
      visibleBrands:props.defaultFilter,
      allBrandsSelected:false
    };
  }

  handleBrandClick(brandId,event){
    event.stopPropagation();

    let existingBrands = this.state.visibleBrands;

    if(existingBrands.indexOf(brandId) < 0){
      existingBrands.push(brandId);
    } else {
      existingBrands.splice(existingBrands.indexOf(brandId),1);
    }

    this.props.onFilterChange(existingBrands);

    this.setState({
      visibleBrands:existingBrands,
      ignoreToggle:true
    });
  }

  handleToggle(event){
    this.setState((prevState,props) => ({
      open:prevState.ignoreToggle? prevState.open : !prevState.open,
      ignoreToggle:false
    }));
  }

  handleAllBrandsClick(event){
    event.stopPropagation();

    const allBrandIds = this.props.brands.map((brand) => brand.id);

    this.setState({
      allBrandsSelected:!this.state.allBrandsSelected,
      visibleBrands:event.target.checked ? allBrandIds : [],
      ignoreToggle:true
    });

    this.props.onFilterChange(event.target.checked ? allBrandIds : []);
  }

  getFilterTitle(){
    if(this.state.visibleBrands.length === 0){
      return 'Filter Brands'
    } else if(this.state.visibleBrands.length === this.props.brands.length) {
      return 'All Brands'
    } else if(this.state.visibleBrands.length < 3){
      return this.props.brands
        .filter((brand) => this.state.visibleBrands.indexOf(brand.id) >= 0)
        .map((brand) => brand.name)
        .join(', ')
    } else {
      const andText = `, and ${this.state.visibleBrands.length - 2} more`;

      return this.props.brands
        .filter((brand) => this.state.visibleBrands.indexOf(brand.id) >= 0)
        .slice(0,2)
        .map((brand) => brand.name)
        .join(', ') + andText;

    }
  }

  getClippedNameIfNeeded(name){
    if(name.length > 25) return `${name.slice(0,20)}...`
    return name;
  }

  isChecked(brandId){
    return this.state.visibleBrands.indexOf(brandId) >= 0 || this.state.allBrandsSelected;
  }

  render(){
    return (
      <NavDropdown
        className='ActiveBrandsDropDown'
        isOpen={this.state.open || this.props.isForcedOpen}
        toggle={this.handleToggle.bind(this)}
        disabled={this.props.brands.length === 0}
      >
        <DropdownToggle
          nav
          caret
          disabled={this.props.brands.length === 0}
          style={{opacity:this.props.brands.length === 0 ? 0.3 : 1}}
        >
          {this.getFilterTitle()}
        </DropdownToggle>
        <DropdownMenu className='ActiveBrandsDropDownMenu'>
          {this.props.brands.map((brand) => (
            <DropdownItem
              key={brand.id}
              onClick={this.handleBrandClick.bind(this,brand.id)}
            >
              <div className='clearfix'>
                <span className='float-left'>
                  {this.getClippedNameIfNeeded(brand.name)}
                  &nbsp;&nbsp;
                </span>
                <input
                  type='checkbox'
                  className='float-right'
                  checked={this.isChecked(brand.id)}
                  disabled={this.state.allBrandsSelected}
                  style={{marginTop:'.5rem'}}
                />
              </div>
            </DropdownItem>
          ))}
          <DropdownItem divider />
          <DropdownItem
            onClick={this.handleAllBrandsClick.bind(this)}
          >
            <div className='clearfix'>
              <span className='float-left'>
                All Brands&nbsp;&nbsp;
              </span>
              <input
                type='checkbox'
                className='float-right'
                checked={this.state.allBrandsSelected}
                style={{marginTop:'.5rem'}}
              />
            </div>
          </DropdownItem>
        </DropdownMenu>
      </NavDropdown>
    )
  }
}

ActiveBrandsDropDown.defaultProps = {
  isUsingPlaceholderData:false,
  isForcedOpen:false,
  brands:[],
  defaultFilter:[],
  onFilterChange:() => {},
  onManageClick:() => {}
}

export default ActiveBrandsDropDown;



// WEBPACK FOOTER //
// ./src/routes/AgencyCampaignsDashboard/components/ActiveBrandsDropDown.js